"use client";

import CTAButton from "./CTAButton";
import { externalLinksData } from "@/data/externalLinksData";

export default function RegistrationLinks() {
    return (
        <div className="w-full bg-zinc-900 border-t border-zinc-800 py-16 mt-20">
            <div className="container mx-auto px-4">
                <div className="text-center mb-16">
                    <h3 className="text-3xl font-display uppercase text-white mb-2">Gestión de Inscripción</h3>
                    <div className="w-24 h-1 bg-primary mx-auto" />
                </div>

                <div className="grid sm:grid-cols-2 gap-6 max-w-4xl mx-auto">
                    {externalLinksData
                        .filter((l) => l.id !== "google-maps-sotet")
                        .map((link, index, array) => {
                            const isLast = index === array.length - 1;
                            const isOdd = array.length % 2 !== 0;
                            return (
                                <a
                                    key={link.id}
                                    href={link.href}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className={`flex items-center gap-4 p-6 bg-zinc-800/50 border border-zinc-700 hover:border-primary transition-all group rounded-lg shadow-sm ${isLast && isOdd ? "sm:col-span-2 sm:max-w-md sm:mx-auto w-full" : ""
                                        }`}
                                >
                                    <span className="w-12 h-12 rounded-full bg-primary/10 text-primary flex items-center justify-center group-hover:bg-primary group-hover:text-black transition-colors">
                                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                                        </svg>
                                    </span>
                                    <div>
                                        <h4 className="font-display uppercase text-lg text-white group-hover:text-primary transition-colors text-left">{link.label}</h4>
                                        {link.description && (
                                            <p className="text-xs text-gray-400 text-left">{link.description}</p>
                                        )}
                                    </div>
                                </a>
                            );
                        })}
                </div>
            </div>
        </div>
    );
}
